module.exports = __webpack_public_path__ + "img/krinnenspitze.e2585825.jpg";